var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 24C6.72914 24 0 18.6167 0 12C0 5.38331 6.72914 0 15 0C23.2709 0 30 5.38331 30 12C30 18.6167 23.2709 24 15 24Z",
    fill: "#C74634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 20C13.7292 20 7.00002 14.6167 7.00002 8.00002C7.00002 5.23031 8.19053 2.68392 10.1682 0.65081C4.26375 2.26458 0 6.73688 0 12C0 18.6167 6.72914 24 15 24C19.8087 24 24.0849 22.1731 26.8318 19.3492C25.3132 19.7643 23.6919 20 22 20Z",
    fill: "#C74634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8964 18.2069C11.6317 18.2069 11.3669 18.1261 11.165 17.9645L4.95812 12.9989C4.554 12.6759 4.554 12.1518 4.95812 11.8286C5.36171 11.5054 6.01738 11.5054 6.42097 11.8286L11.8965 16.2088L22.5444 7.69071C22.948 7.36741 23.6036 7.36741 24.0072 7.69071C24.4114 8.01377 24.4114 8.53788 24.0072 8.86099L12.6279 17.9645C12.4261 18.1261 12.1612 18.2069 11.8964 18.2069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b24e4bd9aff5f4d857a2b2e963f4ccf4.svg";
export { ForwardRef as ReactComponent };